export default __webpack_public_path__ + "static/media/trash.1e0a5b84.svg";